import { FC, Props } from "./typings";
import Chip from "components/Chip";
import Placeholder from "assets/placeholder.png";

const CaseParticipantBadge: FC<Props> = ({
  label,
  onRemove,
}) => {
  return (
    <Chip
      element={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <img src={Placeholder} />

          {label}
        </div>
      }
      onDelete={onRemove}
    />
  );
};

export default CaseParticipantBadge;
